import destinationService from '@/repository/services/v3/destinations'
import { getDestinationSlug } from '@/helpers/getDestinationSlug'
import {
  getFacetsFilterByDestinationUrl,
  getFacetsFilterByUrl,
} from '@/repository/strapi'
import { getDestinationHousesCount } from '@/utils/algolia/services'
import type { RuntimeConfig } from '@nuxt/schema'
import type { Locale } from 'lc-services/types'
import type { SearchDestination } from '@@/types/types'
import type { HttpService } from '@/repository/config/http-service'

// TODO
export const getDestination = async ({
  $apiClient,
  params,
}: {
  $apiClient: HttpService
  params: Record<string, any>
}) => {
  try {
    const destination = await destinationService($apiClient)
      .getPhoto({ ...params })
      .then((res) => (Array.isArray(res) ? res[0] : res))

    return {
      destination: {
        ...destination,
        slug: getDestinationSlug(destination.searchUrl),
      },
    }
  } catch (err) {
    console.error(err)
  }
}

export const getFullDestination = async ({
  $apiClient,
  config,
  params,
}: {
  $apiClient: HttpService
  config: RuntimeConfig
  params: { id?: string; slug?: string }
}) => {
  try {
    const [destinationData, responseHitsData] = await Promise.all([
      destinationService($apiClient)
        .getPhotoAndAncestries(params)
        .then((res) => (Array.isArray(res) ? res[0] : res)),
      getDestinationHousesCount({
        query: params.slug ?? '',
        config,
      }),
    ])

    // ancestriesData
    if (destinationData) {
      const housesCount = responseHitsData?.hits?.length
        ? responseHitsData.hits[0].houses_count
        : 0
      const metaDescription = destinationData.metaDescription
      const metaTitle = destinationData.metaTitle

      return {
        metaDescription,
        metaTitle,
        destination: {
          destinationSlug: getDestinationSlug(destinationData.searchUrl),
          ...destinationData,
          housesCount,
        },
      }
    }
  } catch {
    return {}
  }
}

export const withoutDestination = async ({
  locale,
  slug,
}: {
  locale: Locale
  slug: string
}) => {
  const responseFilterData = await getFacetsFilterByUrl(slug, locale).catch(
    () => null,
  )

  return {
    facets: responseFilterData?.data?.attributes.facets,
    indexation: responseFilterData?.data?.attributes.indexation,
    metaTitle: responseFilterData?.data?.attributes.meta_title[locale],
    metaDesc: responseFilterData?.data?.attributes.meta_description[locale],
    seoTitle: responseFilterData?.data?.attributes.title[locale],
  }
}

export const withDestination = async ({
  $apiClient,
  locale,
  params,
}: {
  $apiClient: HttpService
  locale: Locale
  params: { slug: string; filter: string }
}) => {
  const destinationResponse = await getDestination({
    $apiClient,
    params,
  })

  const responseFilterData = await getFacetsFilterByDestinationUrl(
    params.slug.toString(),
    params.filter.toString(),
    locale,
  )

  return {
    destination: (destinationResponse?.destination ||
      {}) as SearchDestination['destination'],
    facets: responseFilterData?.data?.attributes.facets,
    indexation: responseFilterData?.data?.attributes.indexation,
    metaTitle: responseFilterData?.data?.attributes.meta_title[locale],
    metaDesc: responseFilterData?.data?.attributes.meta_description[locale],
    seoTitle: responseFilterData?.data?.attributes.title[locale],
  }
}
